module.exports = __webpack_public_path__ + "static/img/Recreational_area.663151e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Recreational_area.png
// module id = hRRW
// module chunks = 0